module.exports = __webpack_public_path__ + "8ce2eb78/img/scraper-icon.df6ccde5.svg";